import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {get, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// General
function* getExtensionListRequest() {
    yield takeEvery(actions.EXTENSION_GET_EXTENSION_LIST_REQUEST, function* () {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            //
            const response = yield call(get, '/extensions');
            const data = yield response.data;

            // OK
            yield put({
                type: actions.EXTENSION_GET_EXTENSION_LIST_SUCCESS,
                extensions: data.extensions,
            });
        }
        catch (error) {
            yield put({
                type: actions.EXTENSION_GET_EXTENSION_LIST_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}

// MPS read options
function* mpsReadOptionListRequest() {
    yield takeEvery(actions.EXTENSION_MPS_READ_OPTION_LIST_REQUEST, function* (payload, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/extensions/mps/options', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.EXTENSION_MPS_READ_OPTION_LIST_SUCCESS,
                options: data.options,
            });
        }
        catch (error) {
            yield put({
                type: actions.EXTENSION_MPS_READ_OPTION_LIST_ERROR,
                error,
            });
            message.error(error.message);
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}

// MPS update option list.
function* mpsUpdateOptionListRequest() {
    yield takeEvery(actions.EXTENSION_MPS_UPDATE_OPTION_LIST_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, '/extensions/mps/options', request, context);

            // OK
            yield put({
                type: actions.EXTENSION_MPS_UPDATE_OPTION_LIST_SUCCESS,
            });
            message.success(t`The MPS settings are updated.`);
        }
        catch (error) {
            yield put({
                type: actions.EXTENSION_MPS_UPDATE_OPTION_LIST_ERROR,
                error,
            });
            message.error(error.message);
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}

// MPS synchronise.
function* mpsSynchroniseRequest() {
    yield takeEvery(actions.EXTENSION_MPS_SYNCHRONISE_REQUEST, function* (payload, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/extensions/mps/synchronise', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.EXTENSION_MPS_SYNCHRONISE_SUCCESS,
                log: data.log,
            });
        }
        catch (error) {
            yield put({
                type: actions.EXTENSION_MPS_SYNCHRONISE_ERROR,
                error,
            });
            yield message.error(error.message);
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(getExtensionListRequest),
        fork(mpsReadOptionListRequest),
        fork(mpsUpdateOptionListRequest),
        fork(mpsSynchroniseRequest),
    ]);
}
